export enum EnvironmentType {
  LOCAL,
  DEV,
  PROD,
}
